import { ModelBase } from './model';

class LessonStats extends ModelBase {
  static namespace = 'stats';

  static path = '/api/v2/lesson_stats/';
}
export default LessonStats.register();
